import { Component } from '@angular/core';
import { EnvironmentService } from '@methylium/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ActiveDeviceSyncsProgressBarComponent } from './active-device-syncs-progress-bar.component';
import { AsyncPipe } from '@angular/common';
import { DeviceActiveSyncsStoreSelectors } from '../../sub-features/device-sync/device-active-syncs-store';

@Component({
  selector: 'era-active-device-syncs-progress-bar',
  templateUrl: './active-device-syncs-progress-bar.container.html',
  styleUrls: ['./active-device-syncs-progress-bar.container.scss'],
  imports: [ActiveDeviceSyncsProgressBarComponent, AsyncPipe],
})
export class ActiveDeviceSyncsProgressBarContainerComponent {
  public readonly maximumActiveDeviceSyncs: number;
  public readonly currentActiveDeviceSyncs$: Observable<number[]>;

  constructor(
    private readonly environmentService: EnvironmentService,
    private readonly activeDeviceSyncsStore: Store<number[]>
  ) {
    this.maximumActiveDeviceSyncs = environmentService.environment.maximumSyncLoad;
    this.currentActiveDeviceSyncs$ = this.activeDeviceSyncsStore.select(
      DeviceActiveSyncsStoreSelectors.selectCurrentActiveDeviceSyncs
    );
  }
}
